import React from 'react';

type Props = {
  dimension?: number;
};

const Icon: React.FC<Props> = ({ dimension = 16 }: Props) => (
  <svg width={dimension} height={dimension} viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 26.6667V2.66667C0 1.93333 0.261111 1.30556 0.783333 0.783333C1.30556 0.261111 1.93333 0 2.66667 0H24C24.7333 0 25.3611 0.261111 25.8833 0.783333C26.4056 1.30556 26.6667 1.93333 26.6667 2.66667V18.6667C26.6667 19.4 26.4056 20.0278 25.8833 20.55C25.3611 21.0722 24.7333 21.3333 24 21.3333H5.33333L0 26.6667ZM4.2 18.6667H24V2.66667H2.66667V20.1667L4.2 18.6667Z"
      fill="#5C5C5C"
    />
  </svg>
);

export default Icon;
